import { Grid } from "@material-ui/core";
import { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { DateField } from "../../../../../../../components/forms/date";
import { TextField } from "../../../../../../../components/forms/text";
import { VerificationDTO } from "../../../../../../../store/verification/models/dto/due-diligence";

type FormType = VerificationDTO.Requests.DueDiligence.Form.Post.Final.T["kycRequests"][number];

export const IdDetails: FC<{}> = () => {
  const { t } = useTranslation("fields");

  const { control } = useFormContext<FormType>();

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <strong>Identity Document Details</strong>
      </Grid>
      <Grid item xs={12} md={4}>
        <Controller
          control={control}
          name="identityDocumentDetails.number"
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              error={!!error}
              helperText={error?.message}
              fullWidth
              label={t("identity-number")}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <Controller
          control={control}
          name="identityDocumentDetails.issueDate"
          render={({ field, fieldState: { error } }) => (
            <DateField
              {...field}
              error={!!error}
              helperText={error?.message}
              fullWidth
              label={t("issue-date")}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <Controller
          control={control}
          name="identityDocumentDetails.expiryDate"
          render={({ field, fieldState: { error } }) => (
            <DateField
              {...field}
              error={!!error}
              helperText={error?.message}
              fullWidth
              label={t("expiry-date")}
            />
          )}
        />
      </Grid>
    </Grid>
  );
};
